module.exports = __webpack_public_path__ + "assets/img/page-background-27510d39.jpg";